<button
  data-test-id="wilson-shift-timeline-kpi-setting-button"
  nz-button
  class="my-auto px-2"
  (click)="openKPISettingModal()"
>
  <fa-icon [icon]="faSlidersH"></fa-icon>
</button>
